import TCheckbox from './checkbox.vue'
import TCheckboxGroup from './checkbox-group.vue'

TCheckbox.install = Vue => {
  Vue.component(TCheckbox.name, TCheckbox)
}

TCheckboxGroup.install = Vue => {
  Vue.component(TCheckboxGroup.name, TCheckboxGroup)
}

export {
  TCheckbox,
  TCheckboxGroup
}



// WEBPACK FOOTER //
// ./src/module/checkbox/index.js